module.exports = __webpack_public_path__ + "img/Large-Vertical-Rectangular-Attachment-12.42561844.png";